import {SellerError} from './SellerError.js'

export class TermsAndConditionsNotAcceptedSellerError extends SellerError {}
